var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tags.length > 0)?_c('div',{staticClass:"tags"},_vm._l((_vm.tags),function(tag){return _c('tag',{key:tag.id,attrs:{"name":tag.name,"color":tag.color}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }